/**
 * Wraps a Supabase promise with a timeout.
 * If the promise does not resolve within `ms` milliseconds, it rejects.
 * Also logs start/end/error in development mode.
 *
 * @param {Promise} promise - The Supabase query promise
 * @param {string} label - Human-readable label for logging
 * @param {number} ms - Timeout in milliseconds (default 20000)
 * @returns {Promise}
 */
export async function withTimeout(promise, label = 'supabase', ms = 20000) {
  const isDev = import.meta.env?.DEV;
  const start = Date.now();

  if (isDev) {
    console.log(`[SAVE_START] ${label}`);
  }

  let timeoutId;
  const timeoutPromise = new Promise((_, reject) => {
    timeoutId = setTimeout(() => {
      reject(new Error(`Tiempo de espera agotado (${ms / 1000}s). Reintenta.`));
    }, ms);
  });

  try {
    const result = await Promise.race([promise, timeoutPromise]);
    clearTimeout(timeoutId);
    if (isDev) {
      const elapsed = Date.now() - start;
      console.log(`[SAVE_SUCCESS] ${label} — ${elapsed}ms`, result);
    }
    return result;
  } catch (err) {
    clearTimeout(timeoutId);
    if (isDev) {
      const elapsed = Date.now() - start;
      console.error(`[SAVE_ERROR] ${label} — ${elapsed}ms`, err);
    }
    throw err;
  }
}
